<template>
  <icon :style="{ color: 'hotpink' }">
    <template #component>
      <svg width="1em" height="1em" id="completeIcon" data-name="completeIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path fill="#04c950" class="cls-1" d="M16,32C7.16,32,0,24.84,0,16S7.16,0,16,0s16,7.16,16,16-7.16,16-16,16ZM12.43,22.28c.65.65,1.71.65,2.36,0,0,0,0,0,0,0l10.1-10.1c.65-.65.65-1.71,0-2.36-.65-.65-1.71-.65-2.36,0h0l-9,8.85-4.03-4.03c-.65-.65-1.71-.65-2.36,0-.65.65-.65,1.71,0,2.36,0,0,5.28,5.28,5.28,5.28Z"/>
      </svg>
    </template>
  </icon>
</template>

<script>
import Icon from "@ant-design/icons-vue";

export default {
  name: "completeIcon",
  components: { Icon }
};
</script>

<style scoped>

</style>